enum ActionTypes {
  DELETE_WALLET = '@wallet/DELETE_WALLET',
  GET_ALL_WALLET = '@wallet/GET_ALL_WALLET',
  SET_MANUAL_BONUS = '@wallet/SET_MANUAL_BONUS',
  CALCULATE_ROLLOVER = '@wallet/CALCULATE_ROLLOVER',
  SYNC_BETSOFTBONUS = '@wallet/SYNC_BETSOFTBONUS',
  GET_BONUS_BALANCE = '@wallet/GET_BONUS_BALANCE',
}

export default ActionTypes
